export const truncateString = (string, limit) => {
	if (!string || !limit) return undefined
	if(string.length > limit){
		return string.substring(0, limit) + "..."
	}

	return undefined;
} 